function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

module.exports = _nonIterableSpread;


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/builtin/nonIterableSpread.js
// module id = 436
// module chunks = 114276838955818